module.exports = __webpack_public_path__ + "static/media/banff-49.128e36a2.jpg";